(() => {
  const SCALE_PREFIX = '/collections/scale-collectibles';
  const AUTO_COUNTRY_KEY = 'mt-localization-choice-v1';

  const DEFAULT_SERIES = [
    'Marvel',
    'Star Wars',
    'DC',
    'Batman',
    'Kamen Rider',
    'Aliens',
    'Predator',
    'Death Stranding',
    'KPop Demon Hunters',
    'Arcane',
    'Solo Leveling',
    'The Matrix',
    'Terminator',
    'Masters of the Universe',
    'Pirates of the Caribbean',
    'Indiana Jones'
  ];

  const CURRENCY_CHOICES = [
    { currency: 'USD', country: 'US' },
    { currency: 'EUR', country: 'DE' },
    { currency: 'JPY', country: 'JP' },
    { currency: 'GBP', country: 'GB' },
    { currency: 'CNY', country: 'CN' },
    { currency: 'AUD', country: 'AU' },
    { currency: 'CAD', country: 'CA' },
    { currency: 'CHF', country: 'CH' },
    { currency: 'HKD', country: 'HK' },
    { currency: 'SGD', country: 'SG' }
  ];

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  }

  function normalizeFacetLabels(root = document) {
    root.querySelectorAll('.facets__item[data-filter-param-name="filter-v-availability"] .facets__label')
      .forEach((label) => { label.textContent = 'Availability'; });

    root.querySelectorAll('.facets__summary[data-testid="price-filter"] .facets__label')
      .forEach((label) => { label.textContent = 'Price'; });

    root.querySelectorAll('.facets__label').forEach((label) => {
      const text = label.textContent.trim();
      if (text === '供貨情況') label.textContent = 'Availability';
      if (text === '價格') label.textContent = 'Price';
    });
  }

  function configuredSeries() {
    const raw = document.querySelector('#MechToyScaleSeriesConfig')?.dataset.series || '';
    const values = raw.split(',').map((tag) => tag.trim()).filter(Boolean);
    return values.length ? values : DEFAULT_SERIES;
  }

  function seriesHandle(tag) {
    return String(tag || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['’]/g, '')
      .replace(/&/g, ' and ')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function currentScaleTag() {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!path.startsWith(SCALE_PREFIX + '/')) return '';
    const raw = path.slice(SCALE_PREFIX.length + 1).split('/')[0] || '';
    try { return decodeURIComponent(raw).toLowerCase(); } catch (_) { return raw.toLowerCase(); }
  }

  function seriesLink(tag, activeHandle) {
    const li = document.createElement('li');
    const link = document.createElement('a');
    const handle = seriesHandle(tag);

    link.className = 'mt-series-filter__link';
    link.textContent = tag || 'View all';
    link.href = tag ? `${SCALE_PREFIX}/${handle}` : SCALE_PREFIX;

    const isActive = tag ? activeHandle === handle : activeHandle === '';
    if (isActive) link.setAttribute('aria-current', 'page');

    li.appendChild(link);
    return li;
  }

  function renderSeriesList(list, activeHandle, series) {
    list.replaceChildren();
    list.appendChild(seriesLink('', activeHandle));
    series.forEach((tag) => list.appendChild(seriesLink(tag, activeHandle)));
  }

  function ensureSeriesEmptyState(results, activeHandle, series) {
    const existing = results.querySelector(':scope > .mt-series-empty-state');

    if (!activeHandle) {
      existing?.remove();
      return;
    }

    const selected = series.find((tag) => seriesHandle(tag) === activeHandle);
    if (!selected) {
      existing?.remove();
      return;
    }

    const hasProducts = Boolean(results.querySelector('product-card[data-product-id]'));
    if (hasProducts) {
      existing?.remove();
      return;
    }

    if (existing?.dataset.seriesHandle === activeHandle) return;

    const state = existing || document.createElement('div');
    state.className = 'mt-series-empty-state';
    state.dataset.seriesHandle = activeHandle;
    state.innerHTML = `
      <p class="mt-series-empty-state__eyebrow">Scale Collectibles</p>
      <h3>No ${selected} products are currently available.</h3>
      <p>Products in this series are currently unavailable or have been delisted.</p>
      <a class="mt-series-empty-state__link" href="${SCALE_PREFIX}">View all Scale Collectibles</a>
    `;

    if (!existing) results.appendChild(state);
  }

  function ensureSeriesFilter() {
    if (!window.location.pathname.startsWith(SCALE_PREFIX)) return;
    const results = document.querySelector('#ResultsList');
    if (!results) return;

    results.classList.add('mt-results-with-series');
    const activeHandle = currentScaleTag();
    const series = configuredSeries();
    const signature = series.join('|');
    const existing = results.querySelector(':scope > .mt-series-filter');

    if (existing) {
      const needsRefresh =
        existing.dataset.seriesSignature !== signature ||
        existing.dataset.activeHandle !== activeHandle;

      if (needsRefresh) {
        const list = existing.querySelector('.mt-series-filter__list');
        if (list) renderSeriesList(list, activeHandle, series);
        existing.dataset.seriesSignature = signature;
        existing.dataset.activeHandle = activeHandle;
      }

      ensureSeriesEmptyState(results, activeHandle, series);
      return;
    }

    const aside = document.createElement('aside');
    aside.className = 'mt-series-filter';
    aside.dataset.seriesSignature = signature;
    aside.dataset.activeHandle = activeHandle;
    aside.setAttribute('aria-label', 'Browse Scale Collectibles by series');

    const eyebrow = document.createElement('p');
    eyebrow.className = 'mt-series-filter__eyebrow';
    eyebrow.textContent = 'Scale Collectibles';

    const title = document.createElement('h2');
    title.className = 'mt-series-filter__title';
    title.textContent = 'Browse by Series';

    const list = document.createElement('ul');
    list.className = 'mt-series-filter__list';
    renderSeriesList(list, activeHandle, series);

    aside.append(eyebrow, title, list);
    results.prepend(aside);
    ensureSeriesEmptyState(results, activeHandle, series);
  }

  function rowCurrency(item) {
    const text = item?.querySelector?.('.localization-form__currency')?.textContent?.trim() || '';
    return text.split(/\s+/)[0]?.toUpperCase() || '';
  }

  function currencyLabel(item, fallback) {
    return item?.querySelector?.('.localization-form__currency')?.textContent?.trim() || fallback;
  }

  function countryLabel(item) {
    return item?.querySelector?.('.localization-form__country')?.textContent?.trim() || item?.textContent?.trim() || '';
  }

  function restoreCountryRows(list, countries) {
    let changed = false;
    const popular = list.querySelector('ul.popular-countries');
    if (popular) {
      Array.from(popular.querySelectorAll('.localization-form__list-item[data-value]'))
        .forEach((item) => countries.appendChild(item));
      popular.remove();
      changed = true;
    }

    const oldLabels = Array.from(list.querySelectorAll('.mt-localization-section-label'));
    if (oldLabels.length) {
      oldLabels.forEach((label) => label.remove());
      changed = true;
    }

    if (changed) {
      Array.from(countries.querySelectorAll('.localization-form__list-item[data-value]'))
        .sort((a, b) => countryLabel(a).localeCompare(countryLabel(b)))
        .forEach((item) => countries.appendChild(item));
    }
  }

  function setLocalizationCountry(component, country) {
    const countryInput = component.querySelector('input[name="country_code"]');
    const form = countryInput?.closest('form');
    if (!countryInput || !form || !country) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }

    returnTo.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    storageSet(AUTO_COUNTRY_KEY, 'manual');
    countryInput.value = country;
    form.submit();
  }

  function enhanceCurrencySelectors(root = document) {
    root.querySelectorAll('dropdown-localization-component localization-form-component').forEach((component) => {
      const list = component.querySelector('.localization-form__list');
      const countries = list?.querySelector('ul.countries');
      if (!list || !countries) return;

      restoreCountryRows(list, countries);
      if (component.querySelector('.mt-currency-select-wrap')) return;

      const allItems = Array.from(countries.querySelectorAll('.localization-form__list-item[data-value]'));
      if (!allItems.length) return;

      const choices = [];
      CURRENCY_CHOICES.forEach(({ currency, country }) => {
        let item = allItems.find((candidate) => (
          String(candidate.dataset.value || '').toUpperCase() === country && rowCurrency(candidate) === currency
        ));

        if (!item) item = allItems.find((candidate) => rowCurrency(candidate) === currency);

        if (item && !choices.some((choice) => choice.currency === currency)) {
          choices.push({
            currency,
            country: item.dataset.value,
            label: currencyLabel(item, currency)
          });
        }
      });

      if (!choices.length) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'mt-currency-select-wrap';

      const shell = document.createElement('div');
      shell.className = 'mt-currency-select-shell';

      const select = document.createElement('select');
      select.className = 'mt-currency-select';
      select.setAttribute('aria-label', 'Currency');

      choices.forEach((choice) => {
        const option = document.createElement('option');
        option.value = choice.country;
        option.textContent = choice.label;
        option.dataset.currency = choice.currency;
        select.appendChild(option);
      });

      const currentCountry = String(
        component.querySelector('input[name="country_code"]')?.value || window.Shopify?.country || ''
      ).toUpperCase();
      const currentItem = allItems.find((item) => String(item.dataset.value || '').toUpperCase() === currentCountry);
      const currentCurrency = rowCurrency(currentItem);
      const currentChoice = choices.find((choice) => String(choice.country).toUpperCase() === currentCountry)
        || choices.find((choice) => choice.currency === currentCurrency);
      if (currentChoice) select.value = currentChoice.country;

      select.addEventListener('change', () => setLocalizationCountry(component, select.value));
      shell.appendChild(select);
      wrapper.appendChild(shell);

      const filter = component.querySelector('.country-filter') || component.querySelector('[class*="country-filter"]');
      if (filter) filter.before(wrapper);
      else list.before(wrapper);

      const input = component.querySelector('input[type="search"][name="country_filter"]');
      if (input) {
        input.placeholder = 'Search country';
        input.setAttribute('aria-label', 'Search country');
      }
    });
  }

  function normalizeCurrencyCountryOnce() {
    if (window.Shopify?.designMode) return;

    const representativeByCurrency = {
      USD: 'US',
      EUR: 'DE',
      GBP: 'GB',
      AUD: 'AU',
      AED: 'AE',
      SAR: 'SA',
      INR: 'IN'
    };
    const allowedCountries = new Set(Object.values(representativeByCurrency));
    const currentCountry = String(window.Shopify?.country || '').toUpperCase();

    if (!currentCountry || allowedCountries.has(currentCountry)) return;

    const activeCurrency = String(window.Shopify?.currency?.active || '').toUpperCase();
    const targetCountry = representativeByCurrency[activeCurrency] || 'US';
    const guardKey = `mt-currency-normalized-v3:${currentCountry}:${targetCountry}`;

    try {
      if (window.sessionStorage.getItem(guardKey)) return;
    } catch (_) {}

    const component = document.querySelector('dropdown-localization-component localization-form-component');
    const countryInput = component?.querySelector('input[name="country_code"]');
    const form = countryInput?.closest('form');
    const targetOption = component?.querySelector(`.mecha-currency-option[data-value="${targetCountry}"]`);

    if (!countryInput || !form || !targetOption) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }

    returnTo.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    try {
      window.sessionStorage.setItem(guardKey, '1');
    } catch (_) {}

    countryInput.value = targetCountry;
    form.submit();
  }

  function markManualLocalizationChoice() {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('localization-form-component .localization-form__list-item[data-value]')) return;
      storageSet(AUTO_COUNTRY_KEY, 'manual');
    }, true);
  }

  async function autoDetectCountryOnce() {
    if (!window.Shopify?.routes?.root || !window.Shopify?.country) return;
    if (storageGet(AUTO_COUNTRY_KEY)) return;
    if (window.Shopify.designMode) return;

    try {
      const currentCountry = String(window.Shopify.country).toUpperCase();
      const url = `${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}&language[enabled]=false`;
      const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;

      const data = await response.json();
      const detectedCountry = String(data?.suggestions?.[0]?.parts?.country?.handle || '').toUpperCase();

      if (!detectedCountry || detectedCountry === currentCountry) {
        storageSet(AUTO_COUNTRY_KEY, currentCountry);
        return;
      }

      const component = document.querySelector('dropdown-localization-component localization-form-component');
      const allowed = component?.querySelector(`.localization-form__list-item[data-value="${detectedCountry}"]`);
      const countryInput = component?.querySelector('input[name="country_code"]');
      const form = countryInput?.closest('form');

      if (!allowed || !countryInput || !form) {
        storageSet(AUTO_COUNTRY_KEY, currentCountry);
        return;
      }

      let returnTo = form.querySelector('input[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        form.appendChild(returnTo);
      }
      returnTo.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;

      storageSet(AUTO_COUNTRY_KEY, `auto:${detectedCountry}`);
      countryInput.value = detectedCountry;
      form.submit();
    } catch (_) {}
  }

  function ensureBackToTop() {
    if (document.querySelector('.mt-back-to-top') || !document.body) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mt-back-to-top';
    button.setAttribute('aria-label', 'Back to top');
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m7 14 5-5 5 5"/></svg>';
    document.body.appendChild(button);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => button.classList.toggle('is-visible', window.scrollY > 480);

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  let scheduled = false;
  function applyEnhancements() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      normalizeFacetLabels();
      ensureSeriesFilter();
      ensureBackToTop();
    });
  }

  markManualLocalizationChoice();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyEnhancements();
      normalizeCurrencyCountryOnce();
    }, { once: true });
  } else {
    applyEnhancements();
    normalizeCurrencyCountryOnce();
  }

  new MutationObserver(applyEnhancements).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
